import { CursorObserverSettings } from './cursorObserverSettings';

/**
 *
 */
export class CursorObserver {
  private controller = new AbortController();
  private readonly settings: CursorObserverSettings;
  private handleMouseOut: EventListenerOrEventListenerObject;
  private handleMouseOver: EventListenerOrEventListenerObject;
  private triggerTimer;
  private triggered: boolean = false;

  /**
   *
   * @param settings
   */
  constructor(settings: CursorObserverSettings) {
    this.settings = settings;
    this.handleMouseOut = this.handleStartEvent.bind(this);
    this.handleMouseOver = this.handleStopEvent.bind(this);
    this.start();
    // console.debug('CursorObserver event listener registered');
  }

  /**
   *
   */
  start() {
    this.settings.root.addEventListener('mouseout', this.handleMouseOut, {
      passive: true,
      signal: this.controller.signal,
    });
    this.settings.root.addEventListener('mouseover', this.handleMouseOver, {
      passive: true,
      capture: true,
      signal: this.controller.signal,
    });
  }

  /**
   *
   */
  stop() {
    this.settings.root.removeEventListener('mouseout', this.handleMouseOut);
    this.settings.root.removeEventListener('mouseover', this.handleMouseOver, { capture: true });
    this.controller.abort();
  }

  /**
   *
   */
  handleStartEvent(event: MouseEvent) {
    if (event.target && event.relatedTarget === null && event.clientY <= this.settings.edge.height) {
      let x;
      switch (this.settings.detectOs()) {
        case 'macos':
          x = {
            min: 0,
            max: this.settings.edge.width,
          };
          break;
        default:
          x = {
            min: this.settings.windowSize.width - this.settings.edge.width,
            max: this.settings.windowSize.width,
          };
      }

      if (event.clientX >= x.min && event.clientX <= x.max) {
        if (this.settings.once && this.triggered) {
          // remove listener after first successful trigger
          return;
        }

        // console.log("trigger mouse out of window", x)
        clearTimeout(this.triggerTimer);
        this.triggerTimer = setTimeout(() => {
          // console.log("trigger callback")
          this.settings.callback();
          this.triggered = true;
        }, this.settings.triggerDelayMillis);
      }
    }
  }

  /**
   *
   */
  handleStopEvent(event: MouseEvent) {
    if (event.relatedTarget === null) {
      // console.log("trigger mouse over of window", event)
      clearTimeout(this.triggerTimer);
    }
  }
}
